import React, { Suspense } from 'react';

import { Spinner, Button, Table, Card } from "react-bootstrap";
import { registerLocale } from "react-datepicker";
import pl from "date-fns/locale/pl"; // the locale you want

import FechGetOneRegularReservations from "../APP_RESERVATION_FECH_DATA/FechGetOneRegularReservations";
import FechGetOneRegularReservationsList from "../APP_RESERVATION_FECH_DATA/FechGetOneRegularReservationsList";

import PageCounterNewGet from '../components/PageCounterNewGet';
import BeltReservationApp from '../APP_RESERVATION_COMPONENTS/BeltReservationApp'

import queryString from 'query-string'
import moment from 'moment'
import ParseLinkToArray from "../utils/ParseLinkToArray"

const TabAllReservation = React.lazy(() => import('../APP_RESERVATION_COMPONENTS/TabAllReservation'));

let plLocate = require('moment/locale/pl');
moment.locale('pl', plLocate)

//KLASA WYSWIETLA SZCZEGOLY KONKRETNYCH ZAJEC SZKOLKI
class PageRegularReservationDetails extends React.Component {

    TRAINER_SELECT_DESC = "Wybierz trenera";
    DATE_SELECT_DESC = "Wybierz datę";
    CLASS_SELECT_DESC = "Wybierz szkółke";

    urlDeafulValues = [this.TRAINER_SELECT_DESC, this.CLASS_SELECT_DESC, this.DATE_SELECT_DESC];

    urlValue = "";

    postData = {
        clientId: '',
        sortBy: '',
        ticketStatus: '',
        page: '0'
    };

    constructor(props) {
        super(props);

        this.state = {
            restReservationData: {
                successful: false,
                status: '',
                message: '',
                data: []
            },
            restReservationLogData: {
                successful: false,
                status: '',
                message: '',
                data: []
            }
        }
    }

    async componentDidMount() {

        
        registerLocale("pl", pl); // register it with the name you want
        const { location: { search } } = this.props;
        this.state.search = search;
        this.urlValue = queryString.parse(this.state.search);

        this.postData = await ParseLinkToArray(this.urlValue, this.postData, this.urlDeafulValues);

        const club = this.props.match?.params?.club ?? "";
        const truncatedClub = club.length > 20 ? club.slice(0, 20) : club;
        const title = "Stałe rezerwacje BACKUP " + this.props.match.params.id + " " + truncatedClub + " App - RezerwujKort.pl";
        document.title = title;

        if (window._paq) {
            window._paq.push(['setDocumentTitle', title]);
        }

        this.setState({
            restReservationData: await FechGetOneRegularReservations(this.props.match.params.club,
                this.props.match.params.id)
        });
        this.setState({
            restReservationLogData: await FechGetOneRegularReservationsList(this.props.match.params.club,
                this.props.match.params.id, parseInt(this.props.match.params.page))
        });
    }

    render() {

        var loader = "";
        if (!this.state.restReservationData.successful) {
            loader = <div id="loader_div">
                <Spinner animation="border" />
            </div>
            totalRecords = this.state.restReservationData.data
        }

        var totalRecords = "";
        var totalRecordsLogs = "";
        var tabAllTicketReservations = "";
        var tabAllTicketChangeLogs = "";
        var pageCounter = "";
        var baseInfo = "";
        if (this.state.restReservationData.successful) {

            // totalRecords = this.state.restReservationData.data.reservation.length
            // tabAllTicketReservations = <TabAllTicketReservations
            //     club={this.props.match.params.club}
            //     restLessonsData={this.state.restReservationData.data.reservation} />

            totalRecordsLogs = this.state.restReservationLogData.data.length

            if (this.state.restReservationLogData.successful) {
                
                tabAllTicketChangeLogs = <div>
                    <Suspense fallback={<div>
                        <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
                    </div>}>
                        <TabAllReservation
                            club={this.props.match.params.club}
                            restLessonsData={this.state.restReservationLogData.data.reservationResources} />
                    </Suspense>
                </div>

                totalRecordsLogs = this.state.restReservationLogData.data.totalRecordsCount

                var url = "reservation_app/" + this.props.match.params.club + "/stala_rezerwacja_szczegoly/" +
                    this.props.match.params.id + "/replace";

                pageCounter = <PageCounterNewGet
                    elementCount={totalRecordsLogs}
                    elementOnPage={this.state.restReservationLogData.data.recordsOnPage}
                    currentPage={parseInt(this.props.match.params.page)}
                    linkTo={url}
                />
            }


            baseInfo = <Card style={{ width: '100%' }}>
                <Card.Body>
                    <Card.Title>Informacje o stałej Rezerwacji:</Card.Title>
                    <Table responsive="sm">

                        <tbody>
                            <tr>
                                <td><b>Klient:</b></td>
                                <td>{this.state.restReservationData.data.name}&nbsp;
                                    {this.state.restReservationData.data.surname}&nbsp;
                                    (tel. {this.state.restReservationData.data.phone})</td>
                                <td><b>Trener:</b></td>
                                <td>{this.state.restReservationData.data.trainerName} </td>
                            </tr>
                            <tr>
                                <td><b>Start:</b></td>
                                <td>{this.state.restReservationData.data.dateStart} </td>
                                <td><b>Godzina start:</b></td>
                                <td>{this.state.restReservationData.data.hourStart} </td>
                            </tr>
                            <tr>
                                <td><b>Stop:</b></td>
                                <td>{this.state.restReservationData.data.dateStop} </td>
                                <td><b>Godzina koniec:</b></td>
                                <td>{this.state.restReservationData.data.hourStop} </td>
                            </tr>
                            <tr>
                                <td><b>Dzień tygodnia:</b></td>
                                <td>{this.state.restReservationData.data.dayOfWeek} </td>
                                <td><b>Kort:</b></td>
                                <td>{this.state.restReservationData.data.courtName} </td>
                            </tr>
                            <tr>
                                <td><b>Cena:</b></td>
                                <td>{this.state.restReservationData.data.price} </td>
                                <td><b>Rodzaj płatności:</b></td>
                                <td>{this.state.restReservationData.data.paymentMethodDesc} </td>
                            </tr>
                            <tr>
                                <td><b>Czy opłacona:</b></td>
                                <td>
                                    {this.state.restReservationData.data.payed ? (
                                        <>Tak</>
                                    ) : (
                                        <>Nie</>
                                    )}
                                </td>
                                <td><b>Rodzaj rezerwacji:</b></td>
                                <td>{this.state.restReservationData.data.reservationTypeDesc} </td>
                            </tr>
                            <tr>
                                <td><b>Typ rezerwacji:</b></td>
                                <td>{this.state.restReservationData.data.reservationMethodDesc} </td>
                                <td><b>Nieobecność:</b></td>
                                <td>
                                    {this.state.restReservationData.data.absent ? (
                                        <>Tak</>
                                    ) : (
                                        <>Nie</>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td><b>Karnet kort:</b></td>
                                <td>
                                    {this.state.restReservationData.data.ticketCourt ? (
                                        <>Tak</>
                                    ) : (
                                        <>Nie</>
                                    )}
                                </td>
                                <td><b>Karnet trener:</b></td>
                                <td>
                                    {this.state.restReservationData.data.ticketTrainer ? (
                                        <>Tak</>
                                    ) : (
                                        <>Nie</>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td><b>Karnet kort (ile pobrano):</b></td>
                                <td>
                                    {this.state.restReservationData.data.ticketCourt ? (
                                        <>{this.state.restReservationData.data.ticketCourtPrice}</>
                                    ) : (
                                        <>--</>
                                    )}
                                </td>
                                <td><b>Karnet trener (ile pobrano):</b></td>
                                <td>
                                    {this.state.restReservationData.data.ticketCourt ? (
                                        <>{this.state.restReservationData.data.ticketTrainerPrice}</>
                                    ) : (
                                        <>--</>
                                    )}
                                </td>
                            </tr>
                            <tr>
                            </tr>
                            <tr>
                                <td><b>Kto utworzył:</b></td>
                                <td>{this.state.restReservationData.data.createdByName} {this.state.restReservationData.data.createdBySurname} <br />
                                    {this.state.restReservationData.data.createdByEmail}</td>
                                <td><b>Kiedy dodany:</b></td>
                                <td>{this.state.restReservationData.data.createdAt}</td>
                            </tr>
                            <tr>
                                <td><b>Czy usunięty:</b></td>
                                <td>
                                    {this.state.restReservationData.data.deleted ? (
                                        <>Tak</>
                                    ) : (
                                        <>Nie</>
                                    )}
                                </td>
                                <td><b>Kiedy usunięty:</b></td>
                                <td>
                                    {this.state.restReservationData.data.deleted ? (
                                        <>{this.state.restReservationData.data.deletedAt}</>
                                    ) : (
                                        <>--</>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td><b>Kto usunął:</b></td>
                                <td>
                                    {this.state.restReservationData.data.deleted ? (
                                        <>{this.state.restReservationData.data.deletedByName} {this.state.restReservationData.data.deletedBySurname}
                                            {this.state.restReservationData.data.deletedByEmail}</>
                                    ) : (
                                        <>--</>
                                    )}
                                </td>
                                <td><b>Opis:</b></td>
                                <td>{this.state.restReservationData.data.description} </td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        }

        return (

            <div>

                <div id="content">

                    <BeltReservationApp club={this.props.match.params.club} />

                    {baseInfo}

                    <br /><br />
                    <b>Lista wszystkich rezerwacji: ({totalRecordsLogs}):</b>
                    <br /><br />

                    {tabAllTicketChangeLogs}

                    {loader}

                    {pageCounter}


                </div>
            </div>
        );
    }
}
export default PageRegularReservationDetails;
